(function () {
  "use strict";

  if (window.__kitSetYoutubeModalInit) {
    return;
  }

  window.__kitSetYoutubeModalInit = true;

  class YoutubeIframeModal {
    constructor() {
      this.modal = null;
      this.frame = null;
      this.lastTrigger = null;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.init();
    }

    init() {
      this.create();
      document.addEventListener("click", this.onClick);
      document.addEventListener("keydown", this.onKeydown);
    }

    create() {
      const markup = `
        <div class="youtube-iframe-modal" id="youtubeIframeModal" aria-hidden="true" role="dialog" aria-modal="true">
          <div class="youtube-iframe-modal__overlay" data-youtube-modal-close></div>
          <div class="youtube-iframe-modal__dialog">
            <button class="youtube-iframe-modal__close" type="button" aria-label="Close video" data-youtube-modal-close>
              <svg viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
              </svg>
            </button>
            <div class="youtube-iframe-modal__frame-wrap">
              <iframe class="youtube-iframe-modal__frame" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML("beforeend", markup);
      this.modal = document.getElementById("youtubeIframeModal");
      this.frame = this.modal.querySelector(".youtube-iframe-modal__frame");
    }

    onClick(event) {
      const closeTrigger = event.target.closest("[data-youtube-modal-close]");
      if (closeTrigger) {
        event.preventDefault();
        this.close();
        return;
      }

      const trigger = event.target.closest("[data-youtube-modal-trigger]");
      if (!trigger) {
        return;
      }

      const videoId = trigger.getAttribute("data-youtube-id");
      if (!videoId) {
        return;
      }

      event.preventDefault();
      this.lastTrigger = trigger;
      this.open(videoId);
    }

    onKeydown(event) {
      if (event.key === "Escape" && this.modal?.getAttribute("aria-hidden") === "false") {
        this.close();
      }
    }

    open(videoId) {
      if (!this.modal || !this.frame) {
        return;
      }

      const params = new URLSearchParams({
        autoplay: "1",
        playsinline: "1",
        rel: "0",
        modestbranding: "1",
        enablejsapi: "1",
      });

      this.frame.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
      this.modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      this.modal.querySelector(".youtube-iframe-modal__close")?.focus();
    }

    close() {
      if (!this.modal || !this.frame) {
        return;
      }

      this.frame.src = "";
      this.modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      this.lastTrigger?.focus?.();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => new YoutubeIframeModal(), { once: true });
  } else {
    new YoutubeIframeModal();
  }
})();
